import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context";
import { Trash2 } from "lucide-react";

export const CartDrawer = ( {  updateCart = ()=> {}}  ) => {
  const { isCartOpen, setIsCartOpen, cart, updateQty,cartTotal,removeFromCart, formatPrice} = useAppContext();
  
  const delivery = cartTotal > 30 ? 0 : 3.99;
  const tax = cartTotal * 0.1;
  const navigate = useNavigate();
      

  if (!isCartOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex">
      <div className="flex-1 bg-black/40 backdrop-blur-sm afi" onClick={() => setIsCartOpen(false)}/>
      <div className="w-full max-w-sm bg-white flex flex-col shadow-2xl asr">
        <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
          <div>
            <h2 className="font-serif font-black text-xl text-gray-900">Your Cart</h2>
            <p className="text-xs text-gray-400">{cart.length} items · {formatPrice(cartTotal)}</p>
          </div>
          <button onClick={() => setIsCartOpen(false)} className="w-9 h-9 rounded-xl bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-red-100 hover:text-red-500 transition-colors btn-press">✕</button>
        </div>

        {cart.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
            <div className="text-7xl mb-4 aflt">🛒</div>
            <p className="font-bold text-gray-900 text-lg mb-1">Cart is empty</p>
            <p className="text-sm text-gray-400 mb-6">Add some delicious food!</p>
            <button onClick={() => { setIsCartOpen(false); navigate("/menu")  }} className="bg-[#f97316] text-white font-bold px-6 py-3 rounded-2xl btn-press hover:bg-orange-600 transition-colors">Browse Menu 🍽️</button>
          </div>
        ) : (
          <>
            {cartTotal < 30 && (
              <div className="mx-4 mt-3 bg-orange-50 rounded-xl px-4 py-2.5 flex items-center gap-2">
                <div className="flex-1 h-1.5 bg-orange-100 rounded-full overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-[#f97316] to-red-500 rounded-full transition-all" style={{width:`${(cartTotal/30)*100}%`}}/>
                </div>
                <span className="text-xs font-bold text-orange-600 whitespace-nowrap">+{formatPrice(30-cartTotal)} for free delivery</span>
              </div>
            )}
            <div className="flex-1 overflow-y-auto p-4 space-y-3 thin-scroll">
              {cart.map(item => (
                <div key={item.id} className="flex gap-3 items-center bg-gray-50 rounded-2xl p-3">
                  <img src={item?.images?.image} alt={item.name ? item.name : "no-name"} className="w-14 h-14 rounded-xl object-cover flex-shrink-0"/>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-sm text-gray-900 truncate">{item.name ? item.name : "no-name"}</p>
                    <p className="font-black text-[#f97316] text-sm">{formatPrice(item.price)}</p>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <button onClick={() =>  updateQty(item.id, -1)} className="w-6 h-6 rounded-lg bg-white border border-gray-200 text-xs font-black hover:bg-red-50 hover:border-red-200 transition-colors">−</button>
                    <span className="text-xs font-black w-5 text-center">{item.quantity}</span>
                    <button onClick={() => updateQty(item.id, 1)} className="w-6 h-6 rounded-lg bg-white border border-gray-200 text-xs font-black hover:bg-green-50 hover:border-green-200 transition-colors">+</button>
                  </div>
                    <button 
                onClick={() => removeFromCart(item.id)} 
                className="text-red-300 hover:text-red-500 transition p-1"
            >
                <Trash2 size={18} />
            </button>
                </div>
              ))}
            </div>
            <div className="p-4 border-t border-gray-100">
              <div className="space-y-1.5 text-sm mb-4">
                <div className="flex justify-between text-gray-500"><span>Subtotal</span><span>{formatPrice(cartTotal)}</span></div>
                <div className="flex justify-between text-gray-500"><span>Delivery</span><span className={delivery===0?"text-green-500 font-bold":""}>{delivery===0?"FREE":formatPrice(delivery)}</span></div>
                <div className="flex justify-between text-gray-500"><span>Tax (10%)</span><span>{formatPrice(tax)}</span></div>
                <div className="flex justify-between font-black text-gray-900 text-base border-t border-gray-100 pt-2"><span>Total</span><span className="text-[#f97316]">{formatPrice(cartTotal+tax+delivery)}</span></div>
              </div>
              <button onClick={() => { setIsCartOpen(false); navigate("checkout"); }}
                className="w-full bg-gradient-to-r from-[#f97316] to-red-500 text-white font-black py-4 rounded-2xl hover:shadow-xl hover:shadow-orange-200 transition-all btn-press text-base">
                Checkout →
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};